// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Ah5sj","label":"styles_label__2USFP"};